<template>
  <div class="modal fade" id="additional-warehouse-modal" role="dialog" @click="$emit('close')">
    <div class="modal-dialog modal-lg" @click.stop>
      <div class="modal-dialog modal-lg">
        <div class="modal-content additonal-modal-content">
          <div class="modal-header additional-modal-header">
            <div class="box-item-header">
              <div class="left-item">
                <div class="left-item-header-one">
                  <img class="logi-icon img-responsive" :src="logiSetting.iconUrl" alt="">
                </div>
                <div class="left-item-header-two">
                  <p :class="`logi-kbn m-b-none ${logiSetting.logiKbnItem.class}`">{{ logiSetting.logiKbnItem.name }}</p>
                  <p class="logi-name m-b-none">{{ logiSetting.logiName }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="box-guideline">
              <div class="guideline">
                ガイドライン／利用規約をご確認いただき、<span style="color: #ff0000;">「同意する」ボタンをクリックしてください。</span>
              </div>
              <div class="box-btn-view-pdf text-right">
                <a :href="viewGuidelinePdfUrl" target="_blank" class="btn btn-view-pdf w-150">PDFでみる</a>
              </div>
            </div>
            <div class="box-description">
              <div class="description" v-html="logiSetting.description"></div>
            </div>
            <div class="box-action">
              <div>
                <a class="w-100" data-dismiss="modal" @click="$emit('close')">閉じる</a>
              </div>
              <div class="box-agree">
                <input type="checkbox" name="agree" id="agree" @click="isAgree = !isAgree">
                <label for="agree">上記書面の内容を読み、同意します。</label>
              </div>
              <div>
                <button type="button" class="btn btn-warning btn-add w-130" :disabled="!isAgree" @click.prevent="handleClickRegister()">同意する</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingBlock from '@/components/LoadingBlock'
import WarehouseService from '@/services/warehouseservice'
import WarehouseAcrossService from '@/services/warehouseacrossservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    LoadingBlock
  },
  props: {
    logiSetting: {
      type: Object,
      default () {
        return null
      }
    },
    redirectUrl: {
      type: String,
      default: '/warehouse-across/top'
    }
  },
  data () {
    return {
      loader: null,
      isAgree: false
    }
  },
  computed: {
    viewGuidelinePdfUrl () {
      if (this.logiSetting.systemName === 'salmonAcross') {
        return 'https://image-yoshino.sakura.ne.jp/monster/documents/logiAcross_kiyaku.pdf'
      }
      if (this.logiSetting.systemName === 'salmonSc') {
        return 'https://image-yoshino.sakura.ne.jp/monster/documents/logiSc_kiyaku.pdf'
      }
    }
  },
  methods: {
    handleClickRegister () {
      this.loader = this.$loading.show()
      if (this.logiSetting.systemName === 'salmonAcross') {
        WarehouseAcrossService.register()
          .then(response => {
            this.loader && this.loader.hide()
            this.$emit('close')
            this.$router.push(this.redirectUrl)
          })
          .catch(error => {
            this.loader && this.loader.hide()
            this.$emit('close')
            this.$store.commit('toggleModal', {
              show: true,
              message: error
            })
          })

        let logParams = {
          name: eventCode.warehouses.click_regis_across_warehouse_button,
          properties: {
            seq: this.logiSetting.seq,
            logiName: this.logiSetting.logiName
          }
        }
        EventService.postTrackLog(logParams)
      }

      if (this.logiSetting.systemName === 'salmonSc') {
        WarehouseService.regisScWarehouse()
          .then(response => {
            this.loader && this.loader.hide()
            this.$emit('close')
            this.$router.push('/warehouse-sc/top')
          })
          .catch(error => {
            this.loader && this.loader.hide()
            this.$emit('close')
            this.$store.commit('toggleModal', {
              show: true,
              message: error
            })
          })

        let logParams = {
          name: eventCode.warehouses.click_regis_sc_warehouse_button,
          properties: {
            seq: this.logiSetting.seq,
            logiName: this.logiSetting.logiName
          }
        }
        EventService.postTrackLog(logParams)
      }
    }
  },
  mounted () {
    $('#additional-warehouse-modal').modal('show')
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/warehouses/AdditionalWarehouseModal.vue